import React, { Ref, useEffect, useImperativeHandle, useState } from "react";
import { fields as allFields } from "./config";
import { Form } from "antd";
import { convertIosStringToDate, formatDateToString } from "helper/common";
import moment from "moment";
import PatientInfoCommon from "components/common/PatientInfoCommon/PatientInfoCommon";
import { useAppSelector } from "redux/hooks";
import dayjs from "dayjs";
// import { setNguoiDocKetQua } from "redux/reducer/electrocardiography";

export type PatientInfoRef = {
  getFormValue: () => any;
  setFieldValue: (name, value) => void;
};

type Props = {
  detailElectrocardiography: any;
  electrocardiographyInfoRef: any;
  ref?: Ref<PatientInfoRef>;
};
const PatientInfo = React.forwardRef<PatientInfoRef, Props>((props, ref) => {
  const electroRef = useAppSelector((e) => e.electrocardiography.electroRef);
  const { detailElectrocardiography, electrocardiographyInfoRef } = props;
  const [form] = Form.useForm();
  //set lai value
  useEffect(() => {
    form.setFieldsValue({
      ...detailElectrocardiography,
      ngayTao: detailElectrocardiography?.ngayTao
        ? dayjs(detailElectrocardiography.ngayTao)
        : "",
      thoiGianChiDinh: detailElectrocardiography?.thoiGianChiDinh
        ? moment(detailElectrocardiography.thoiGianChiDinh)
        : null,
      tuoi:
        moment().year() -
        convertIosStringToDate(detailElectrocardiography?.ngaySinh)?.year(),
      nguoiDocKetQua: electrocardiographyInfoRef.current.nguoiDocKetQua,
      // detailElectrocardiography?.nguoiDocKetQua != "" &&
      // detailElectrocardiography?.nguoiDocKetQua
      //   ? detailElectrocardiography?.nguoiDocKetQua
      //   : "Đỗ Thị Liên",
    });
  }, [detailElectrocardiography]);

  // useEffect(() => {
  //   dataFields.find((e) => e.name === "nguoiDocKetQua").onChange = (e) => {
  //     electroRef.setFieldValue("nguoiDocKetQua", e.target.value);
  //   };
  // }, [electroRef]);

  const formatFormValue = () => {
    const rawValues = form.getFieldsValue();
    const formatValues = {
      ...detailElectrocardiography,
      ...rawValues,
      ngaySinh: formatDateToString(rawValues.ngaySinh, null),
    };
    return formatValues;
  };

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      return formatFormValue();
    },
    setFieldValue(name, value) {
      form.setFieldValue(name, value);
    },
  }));

  return (
    <div className="patient-info">
      <Form labelAlign="left" form={form}>
        <PatientInfoCommon
          data={detailElectrocardiography}
          fields={allFields}
        />
      </Form>
    </div>
  );
});
export default PatientInfo;
